import React, { ComponentProps, useEffect } from 'react';
import { motion, useAnimate, animate, stagger } from 'framer-motion';

export function WelcomeGraphics(props: ComponentProps<'svg'>) {
  const [scope, animate] = useAnimate();
  useEffect(() => {
    animate('g', { x: 100 }, { delay: stagger(0.1) });
  }, [animate]);

  return (
    <svg
      viewBox="0 0 488 426"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={scope}
      {...props}
    >
      <path
        className="fill-gray-200 dark:fill-neutral-900"
        d="M243.71 425.161c134.597 0 243.71-65.886 243.71-147.16s-109.113-147.16-243.71-147.16S0 196.727 0 278.001s109.113 147.16 243.71 147.16z"
        // fill="var(--surface3)"
      />
      <g fill="var(--surface4)" className="fill-gray-300 dark:fill-neutral-800">
        <path d="M13.91 288.662l207.8 121.18a9.319 9.319 0 008.42 0l114-65.82c2.33-1.35 2.33-3.52 0-4.87l-207.78-121.18a9.334 9.334 0 00-8.43 0l-114 65.83c-2.34 1.34-2.34 3.52-.01 4.86zM241.22 158.371c8.72 5.09 8.72 13.34 0 18.43s-22.85 5.09-31.57 0c-8.72-5.09-8.72-13.34 0-18.43s22.85-5.09 31.57 0zM452.05 225.642l-137.34-79.31a5.442 5.442 0 00-5.07-.08l-76.41 44.28c-1.41.82-1.41 2.13 0 2.95l33.06 19.05-28.58 19.28c-9.16 6.17-11.13 14.33-4.4 18.21 6.73 3.88 22.53 4.16 32.43-.74l32.77-18.18 13.72 7.92 58.1 33.58a5.685 5.685 0 005.11 0l76.62-44c1.36-.76 1.38-2.07-.01-2.96z" />
      </g>
      <path
        d="M331.34 339.741l-100.8 58.19a10.815 10.815 0 01-10.51.19L37.1 292.951c-3.2-1.84-5.79-6-5.79-9.22 0-3.22 2.59-7.37 5.78-9.22l100.43-58a12.816 12.816 0 0111.57 0l182.25 104.79c3.2 1.85 5.79 6 5.79 9.22 0 3.22-2.59 7.38-5.79 9.22z"
        fill="var(--color-brand-hsl)"
      />
      <path
        opacity={0.5}
        d="M137.52 216.531l-100.43 58c-3.19 1.85-5.79 6-5.78 9.22.01 3.22 2.59 7.38 5.78 9.22l182.94 105.15a11.053 11.053 0 005 1.25V260.5l-76-43.969a12.823 12.823 0 00-11.51 0z"
        fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
      />
      <path
        opacity={0.4}
        d="M230.54 397.931l100.8-58.19c3.2-1.84 5.79-6 5.79-9.22 0-3.22-2.59-7.37-5.79-9.22l-106.28-60.36v138.43a10.65 10.65 0 005.48-1.44z"
        fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
      />
      <path
        d="M229.15 388.531a11.33 11.33 0 01-10.21 0l-181.87-105c-4.32-2.5-4.32-6.58 0-9.07l100.44-57.93a12.841 12.841 0 0111.58 0l183.24 105.77c3.19 1.84 3.19 4.85 0 6.68l-103.18 59.55z"
        fill="var(--color-brand-hsl)"
      />
      <path
        opacity={0.3}
        d="M229.15 388.531a11.33 11.33 0 01-10.21 0l-181.87-105c-4.32-2.5-4.32-6.58 0-9.07l100.44-57.93a12.841 12.841 0 0111.58 0l183.24 105.77c3.19 1.84 3.19 4.85 0 6.68l-103.18 59.55z"
        fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
      />
      <path
        d="M228.39 381.882a12.127 12.127 0 01-11 0l-172.84-99.79c-3-1.75-3-4.6 0-6.35l94.48-54.55a12.257 12.257 0 0111 0l172.84 99.79c3 1.75 3 4.61 0 6.36l-94.48 54.54z"
        fill="var(--color-brand-hsl)"
      />
      <path
        d="M144.2 219.901a11.209 11.209 0 00-5.17 1.29l-94.48 54.55c-3 1.75-3 4.6 0 6.35l18.73 10.81 80.92-51.67v-21.33z"
        fill="var(--color-brand-hsl)"
      />
      <path
        d="M150.1 225.321a12.246 12.246 0 00-11 0l-94.49 54.55a5.712 5.712 0 00-1.43 1.15c.397.427.859.788 1.37 1.07l172.84 99.79a12.125 12.125 0 0011 0l94.49-54.54a5.832 5.832 0 001.42-1.14 5.53 5.53 0 00-1.36-1.09l-172.84-99.79z"
        fill="var(--color-brand-hsl)"
      />
      <path
        opacity={0.75}
        d="M150.1 225.321a12.246 12.246 0 00-11 0l-94.49 54.55a5.712 5.712 0 00-1.43 1.15c.397.427.859.788 1.37 1.07l172.84 99.79a12.125 12.125 0 0011 0l94.49-54.54a5.832 5.832 0 001.42-1.14 5.53 5.53 0 00-1.36-1.09l-172.84-99.79z"
        fill="#fff"
      />
      <path
        d="M107.839 233.651a.997.997 0 001-1 .997.997 0 00-1-1 3.752 3.752 0 00-3.39 0 1 1 0 100 2 3.755 3.755 0 003.39 0zM114.63 229.721a.997.997 0 00.559-.352.996.996 0 000-1.247.996.996 0 00-.559-.351 3.713 3.713 0 00-3.4 0 1.002 1.002 0 00-.778.975 1 1 0 00.778.975 3.712 3.712 0 003.4 0z"
        fill="#37474F"
      />
      <g>
        <path
          opacity={0.15}
          d="M148.109 327.151l26.15 15.16a3.115 3.115 0 002.85 0l75.06-43.27a.867.867 0 00.43-1.333.869.869 0 00-.43-.317l-26.15-15.16a3.148 3.148 0 00-2.85 0l-75.06 43.3a.87.87 0 000 1.62z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M249.109 295.161a1.001 1.001 0 00-.58-.81l-23.39-13.5a3.05 3.05 0 00-2.79 0l-71.39 41.28a1.007 1.007 0 00-.58.81v2.45a.995.995 0 00.58.81l23.39 13.5a3.102 3.102 0 002.79 0l71.39-41.17a.996.996 0 00.58-.8v-2.57z"
          fill="#263238"
        />
        <path
          d="M174.349 337.181l-23.39-13.44a.854.854 0 01-.577-.805.856.856 0 01.577-.805l71.39-41.28a3.048 3.048 0 012.79 0l23.39 13.5a.856.856 0 01.577.805.854.854 0 01-.577.805l-71.39 41.22a3.052 3.052 0 01-2.79 0z"
          fill="#37474F"
        />
        <path
          d="M175.649 337.532v2.51a2.818 2.818 0 01-1.31-.32l-23.37-13.5a1 1 0 01-.58-.81v-2.48a1 1 0 00.58.81l23.37 13.45c.405.211.853.328 1.31.34z"
          fill="#263238"
        />
        <path
          d="M223.568 282.982l2.32 1.33-3.14 1.82-2.4-1.35 3.14-1.81.08.01zm3.63 2.09l2.31 1.34-2.46 1.42-2.34-1.3 2.47-1.43.02-.03zm-8 .44h.05l2.32 1.34-2.47 1.42-2.39-1.33 2.46-1.43h.03zm11.64 1.65l2.32 1.34-4 2.3-2.39-1.34 4-2.3h.07zm-7.34.05l2.32 1.34-2 1.13-2.39-1.34 2-1.13h.07zm-8 .45h.05l2.32 1.33-2.47 1.43-2.39-1.35 2.46-1.42.03.01zm4.8 1.41h.06l2.31 1.33-1.96 1.13-2.39-1.34 2-1.13-.02.01zm14.18.19l2.31 1.33-3.08 1.83-2.39-1.35 3.14-1.81h.02zm-22.69.54l2.31 1.34-17.82 10.29-2.4-1.35 17.83-10.28h.08zm13.83.38h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm-8.52.74l2.32 1.33-2 1.13-2.4-1.34 2-1.13.08.01zm21 .43l2.32 1.34-2 1.13-2.4-1.35 2-1.13.08.01zm-8 .44h.05l2.31 1.34-2 1.13-2.39-1.35 2-1.13.03.01zm-7.68.25h.05l2.32 1.33-2 1.13-2.4-1.34 2-1.13.03.01zm-8.52.73l2.32 1.34-2 1.13-2.4-1.35 2-1.13.08.01zm21 .43h.06l2.31 1.34-2 1.13-2.39-1.35 2-1.13.02.01zm-8 .44h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm-7.68.25h.06l2.31 1.33-2 1.13-2.39-1.34 2-1.13.02.01zm23.3 0h.05l2.32 1.33-2.47 1.43-2.39-1.35 2.46-1.42.03.01zm-31.82.73h.01l2.31 1.34-2 1.13-2.31-1.34 1.95-1.13h.04zm21 .43h.01l2.31 1.34-2 1.13-2.31-1.34 2-1.13h-.01zm-8 .44l2.32 1.34-2 1.13-2.31-1.33 2-1.13-.01-.01zm-7.67.25h.05l2.31 1.34-2 1.13-2.39-1.35 2-1.13.03.01zm-8.52.73l2.31 1.34-2 1.13-2.39-1.35 2-1.13.08.01zm29.91.37l2.32 1.33-2 1.14-2.4-1.35 2-1.13.08.01zm-8.91.06l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.08zm-8 .44h.06l2.31 1.34-2 1.13-2.43-1.28 2-1.13.06-.06zm-7.67.25l2.32 1.34-2 1.13-2.4-1.35 2-1.13.08.01zm-8.52.73h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm29.91.37h.06l2.31 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm-8.91.06h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm-8 .45l2.32 1.33-2 1.13-2.4-1.34 2-1.13.08.01zm-7.68.24l2.32 1.34-2 1.13-2.39-1.38 1.95-1.13.12.04zm-8.52.74h.05l2.32 1.33-2 1.13-2.39-1.34 1.95-1.13.07.01zm29.92.36l2.31 1.34-2 1.13-2.39-1.35 2-1.13.08.01zm-8.92.07h.06l2.31 1.33-2 1.13-2.39-1.34 2-1.13.02.01zm-29.35.2h-.06l2.32 1.34-2.47 1.42-2.39-1.34 2.46-1.43.14.01zm21.34.24h.05l2.32 1.33-2 1.14-2.4-1.35 2-1.13.03.01zm-7.67.24h.05l2.31 1.34-2 1.13-2.39-1.34 2-1.13h.03zm-8.52.74l2.31 1.33-2 1.13-2.39-1.34 2-1.13.08.01zm29.91.36h.05l2.32 1.34-2 1.13-2.49-1.33 2-1.13.12-.01zm-8.91.07l2.32 1.33-2 1.14-2.39-1.35 2-1.13.07.01zm-8 .44h.06l2.31 1.34-2 1.13-2.39-1.35 2-1.13.02.01zm-21.84.06h.05l2.32 1.33-2.47 1.43-2.39-1.35 2.46-1.42.03.01zm14.17.18l2.26 1.39-2 1.13-2.4-1.34 2-1.13.14-.05zm-8.52.74h-.02l2.32 1.34-2 1.13-2.4-1.35 2-1.13.1.01zm21 .43h-.02l2.32 1.34-2 1.13-2.4-1.35 2-1.13.1.01zm-8 .44l2.32 1.34-2 1.13-2.39-1.35 2-1.13.07.01zm-7.68.25h.05l2.32 1.33-2 1.13-2.4-1.34 2-1.13.03.01zm23.21 0l2.31 1.34-2 1.13-2.39-1.35 2-1.13.08.01zm-37.88.05l2.31 1.34-2.46 1.42-2.4-1.35 2.47-1.42.08.01zm6.15.63h.05l2.32 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm21 .43h.06l2.31 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm-8 .44h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm-7.68.25h.06l2.31 1.34-2 1.13-2.51-1.29 2-1.13.14-.05zm23.21.05h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm-38.39.34l2.32 1.34-3.14 1.81-2.4-1.34 3.14-1.81h.08zm6.66.34h.06l2.31 1.34-6.31 3.66-2.39-1.35 6.18-3.57.15-.08zm21 .43h.05l2.31 1.34-2 1.13-2.39-1.35 2-1.12h.03zm-8 .44h.06l2.31 1.34-2 1.13-2.39-1.34 1.95-1.13h.07zm-7.67.25h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm23.2.05h.05l2.32 1.34-2 1.13-2.52-1.28 1.95-1.13.2-.06zm-10.72 1.11h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm-29.52.31l2.32 1.33-2 1.13-2.4-1.34 2-1.13.08.01zm21.51.14h.05l2.31 1.33-2 1.13-2.39-1.34 2-1.13.03.01zm-7.68.24h.05l2.32 1.34-1.79 1a.389.389 0 00-.145.137.385.385 0 00-.055.193.386.386 0 00.21.34l3 1.75-2.3 1.33-6-3.44 4.66-2.69.05.04zm23.21.05h.05l2.31 1.34-2 1.13-2.39-1.34 2-1.13h.03zm-10.73 1.12l2.32 1.33-2 1.13-2.39-1.34 2-1.13.07.01zm-29.52.3h.05l2.32 1.33-2.07 1.23-2.39-1.35 1.95-1.13.14-.08zm21.51.14h.05l2.32 1.33-2 1.13-2.4-1.34 2-1.13.03.01zm14.13 1.1h.06l2.31 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm-9.32.31h.05l2.31 1.33-2 1.14-2.39-1.35 2-1.13.03.01zm-29.53.3h.06l2.31 1.34-2 1.13-2.39-1.35 2-1.13.02.01zm6.84.24h.05l2.31 1.34-2 1.13-2.39-1.35 2-1.13.03.01zm28.81 1h.05l2.31 1.34-2 1.13-2.5-1.28 2-1.13.14-.06zm-9.33.31h.05l2.32 1.33-3.48 2-2.4-1.34 3.48-2 .03.01zm-30.2.69h.05l2.32 1.34-5.17 3-2.39-1.35 5.16-3 .03.01zm21.17.33h.06l2.31 1.34-2 1.13-2.39-1.34 2-1.13h.02zm15.15.53h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm-32.69 1.23h.05l2.31 1.34-2 1.13-2.39-1.34 2-1.13h.03zm14.34.1h.05l2.31 1.33-2 1.13-2.39-1.34 2-1.13.03.01zm6.83.24l2.32 1.33-2 1.14-2.4-1.35 2-1.13.08.01zm8.31.28l2.32 1.33-2 1.13-2.39-1.34 2-1.13.07.01zm-39.52 1h.05l2.32 1.34-2 1.13-2.4-1.34 2-1.13h.03zm6.83.25h.05l2.32 1.33-2 1.13-2.4-1.34 2-1.13.03.01zm14.34.09h.05l2.18 1.42-2 1.14-2.4-1.35 2-1.13.17-.08zm-7.51.15h.05l2.32 1.33-2 1.13-2.39-1.34 1.95-1.13.07.01zm14.34.09h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm7.61.69h.05l2.31 1.33-2 1.14-2.39-1.35 2-1.13.03.01zm-38.82.59h.05l5.94 3.42-2 1.14-6-3.44 2-1.13.01.01zm6.83.24h.06l2.31 1.33-2 1.14-2.39-1.35 2-1.13.02.01zm6.83.24h.06l2.31 1.33-2 1.14-2.39-1.35 2-1.13.02.01zm14.34.09h.06l2.31 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm-7.5.15h.05l2.31 1.34-2 1.13-2.49-1.29 2-1.13.13-.05zm15.11.54l2.32 1.34-2 1.13-2.4-1.35 2-1.13.08.01zm-25.15 1.07h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm6.83.24h.05l2.32 1.34-2 1.13-2.4-1.35 2-1.13.03.01zm6.72.33l2.32 1.34-2 1.13-2.4-1.35 2-1.13.08.01zm8.28.3h.05l2.32 1.34-2 1.13-2.39-1.35 1.95-1.13.07.01zm-25.15 1.07h.05l5.94 3.43-2 1.13-6-3.44 2-1.13.01.01zm6.83.24l2.32 1.34-2 1.13-2.28-1.39 2-1.12-.04.04zm6.83.24h.05l2.32 1.34-2 1.13-2.39-1.34 2-1.13h.02zm8.51 1.15l1 .57-2 1.13-1.08-.58 2-1.13.08.01zm-11.74.62h.05l2.31 1.34-2 1.13-2.39-1.34 2-1.13h.03zm8.53 1.23h.06l1 .57-2 1.13-1.07-.58 1.94-1.13.07.01zm-11.74.63h.05l2.32 1.33-2 1.13-2.4-1.34 2-1.13.03.01zm8.54 1.22h.05l1 .57-2 1.13-1.07-.58 2-1.12h.02zm-3.21 1.85l1 .57-2 1.13-1.08-.58 2-1.12h.08z"
          fill="var(--color-brand-hsl)"
        />
      </g>
      <g>
        <path
          opacity={0.1}
          d="M89.71 298.811c1.08 2.73 3.41 4.15 6.86 5.69 10.1 4.55 34.31 10 47.9 12.42 7.91 1.41 16 4 24.08 4.35 7.23.29 14.73-1 20.73-5.08a4.494 4.494 0 001.94-2.11 3.408 3.408 0 00-1.69-3.75 10.193 10.193 0 00-4.27-1.13 174.2 174.2 0 01-46.81-12.41c6.71-.71 13.53-1.44 19.77-4s12-7.23 14.16-13.61c.44-1.28.8-2.7 1.86-3.55a4.297 4.297 0 014.08-.38c4.39 1.57 6.13 6.71 7.43 11.19 1.3 4.48 3.46 9.59 8 10.62-1.65-1-1-3.86.74-4.55s3.87.39 4.93 2c1.06 1.61 1.33 3.44 2.21 5.07.88 1.63 2.77 3 4.48 2.33a4.222 4.222 0 002-2.14c2.42-4.73 2-10.56-.14-15.43-2.14-4.87-5.73-8.95-9.57-12.62-5.35-5.11-11.37-9.7-18.3-12.3-14.5-5.45-30.81-1.48-45.18 4.32a187.834 187.834 0 00-31.09 16.05 52.15 52.15 0 00-10.24 8c-2.19 2.34-4.49 5.66-4.26 9 .024.689.152 1.37.38 2.02z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M212.61 283.241c-2.12-3.28-5.92-10-7.11-11.38-3.25-3.7-9.95-9.55-9.95-9.55-6.32-5.15-25.73-22.29-25.73-22.29s-3-38-6.36-44.08c-3.88-7.08-11.26-7.37-18.9-7.83 0 0-2 8.25-2.78 15 0 0 6.87 42.62 7.69 46.58.82 3.96 2.83 5.7 6.92 8.33 6.25 4 28.86 16.15 28.86 16.15l1.11.77a4.443 4.443 0 011.64 2.18c.293.877.491 1.782.59 2.7.36 3.15 0 4 .27 7.44.27 3.44 1 3.33 2.35 6.28 1.21 2.73 1.57 4.44 2.57 4.54 1 .1 2.28-2.12 2.28-4.37s-1.37-4.73-1.42-5.68c-.05-.95.45-2.13 2.59-.87 2.14 1.26 4.14 5.09 5.73 7.74 1.59 2.65 2.44 6.15 4.05 8.06 1.61 1.91 2.21-.21 2.95-2 .74-1.79 4.35-4.71 5.3-7.57.95-2.86-.55-6.86-2.65-10.15z"
          fill="#FFA8A7"
        />
        <path
          d="M144.56 187.872c5.26 0 9.53-.58 14.16 2.24 4.63 2.82 5.88 6.68 6.93 12.68.95 5.46 2.88 24.26 2.88 24.26s-13.36 7.37-25 2.67l1.03-41.85z"
          fill="#37474F"
        />
        <path
          d="M155.62 162.091a29.687 29.687 0 016.34 2.94 5.591 5.591 0 011.93 7.58l-2.41-.48s1.24-2.83-.21-4.34c-1.45-1.51-5.69-2.82-5.69-2.82l.04-2.88z"
          fill="#263238"
        />
        <path
          d="M162.89 171.041c-2-.95-2.9.27-4.28 3.59-1.38 3.32-.43 4.23 1.25 4.89 1.68.66 3-.45 4-3.2 1.16-3.09 1.13-4.25-.97-5.28z"
          fill="var(--color-brand-hsl)"
        />
        <path
          opacity={0.1}
          d="M163.05 171.071c-2-.95-2.9.27-4.28 3.59-1.38 3.32-.43 4.23 1.25 4.89 1.68.66 3-.45 4-3.2 1.17-3.09 1.14-4.25-.97-5.28z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M122.86 190.291c-11 2.47-22.82 6-31.68 9.85 0 0-.71 37.91 5.43 56 6.14 18.09 4.37 38.7 4.37 38.7 30 4.85 66.39-9.09 65.49-24.21a67.043 67.043 0 00-5.06-9.1s-.75-12.15-.42-17.56c22-20.59-8.55-47-16.43-56.06-4.8.62-11.85.17-21.7 2.38z"
          fill="#455A64"
        />
        <path
          d="M121.05 134.581c-1.42 2.55-.83 5.56-.25 8.26.45 2.06 1.68 4.61 1.16 6.7a13.545 13.545 0 01-5 7.18c-.594.496-1.226.944-1.89 1.34-.57.31-1.23.45-1.81.77a8.109 8.109 0 00-2.95 3 22.638 22.638 0 00-2.14 5.68 19.831 19.831 0 01-2.25 5.63 11.635 11.635 0 01-10.34 4.89 13.99 13.99 0 01-6.23-2 16.53 16.53 0 01-2.67-2 6.768 6.768 0 01-1.76-2.34 11.279 11.279 0 001.88 7.57 13.256 13.256 0 01-11.51-3.502 13.26 13.26 0 01-3.94-11.368c.36-2.56 1.45-5 2-7.49 1.52-6.8-4.58-10.52-5.58-16.72a9.611 9.611 0 014.9-9.8c2.09-1.1 4.84-1.65 5.71-3.84.67-1.68-.15-3.55-.12-5.36 0-3.58 3.38-6.31 6.78-7.39 3.4-1.08 7.09-1.07 10.52-2.09 3.66-1.08 7-3.31 10.72-4a13.822 13.822 0 0112.2 4.16c1.41 1.5 2.18 3.25 3.43 4.8 1.25 1.55 3.16 2.35 4.08 4.17a8.41 8.41 0 01.26 7.74c-1.25 2.39-3.9 3.7-5.2 6.01z"
          fill="#37474F"
        />
        <path
          d="M154.88 142.661c-.42-11.9-7.33-28.88-32.9-26.71-24.92 2.12-32.25 24.35-30 36.42 3.17 16.66 15.29 17.73 18.44 28.62l44.46-38.33z"
          fill="#455A64"
        />
        <path
          d="M99.15 151.761a5.997 5.997 0 016.26-2.08 6.172 6.172 0 013.08 2c1.15 1.27 1.13 3 1.94 4.45a3.286 3.286 0 002.44 1.77c3.43.31 2.15-5.26 2.34-7.24 6.48-2.3 6.3-4.7 7.18-10.42 4.54-4.9 12.42-5.62 19.24-.93 4.16-8 8.67-7 10.62-4.53a31.98 31.98 0 012.91 9.31 61.869 61.869 0 011.09 14.69c-.84 19.11-7.14 23.7-10.28 25-3.14 1.3-7 .36-12.77-.73v11.48c6 11.45 10.79 28.78 10.56 40.1-9.23-17.48-23.68-26.83-30.51-33.18a26.213 26.213 0 01-4.13-4.76v-30.16s-2.52 2.69-6.52-.49c-5.35-4.28-6.99-10.28-3.45-14.28z"
          fill="#FFA8A7"
        />
        <path
          d="M133.2 183.071c-5-1.3-10.35-3.19-14-6a17.286 17.286 0 01-5.42-7.61s.43 7.37 4.14 10.69c3.71 3.32 15.32 7.15 15.32 7.15l-.04-4.23z"
          fill="#F28F8F"
        />
        <path
          d="M133.98 156.431a2.651 2.651 0 01-2.862 2.895 2.649 2.649 0 01-.138-5.265 2.694 2.694 0 013 2.37zM152.76 154.101a2.432 2.432 0 01-2 2.79 2.302 2.302 0 01-2.72-2.15 2.397 2.397 0 011.174-2.396 2.382 2.382 0 011.821-.245 2.379 2.379 0 011.461 1.115c.159.272.262.573.304.886h-.04z"
          fill="#263238"
        />
        <path
          d="M139.53 150.791l1.88 15.92 8.18-3.12-10.06-12.8z"
          fill="#F28F8F"
        />
        <path
          d="M132.56 148.401l-6 2.74a3.44 3.44 0 011.67-4.47 3.23 3.23 0 012.536-.062 3.228 3.228 0 011.794 1.792z"
          fill="#263238"
        />
        <path
          d="M130.63 168.711l8.61 2.92a4.773 4.773 0 01-5.94 2.9 4.45 4.45 0 01-2.574-2.341 4.448 4.448 0 01-.096-3.479z"
          fill="#B16668"
        />
        <path
          d="M130.84 170.722a4.47 4.47 0 014.22 4 4.473 4.473 0 01-1.76-.22 4.327 4.327 0 01-2.9-3.74c.146-.024.293-.037.44-.04z"
          fill="#F28F8F"
        />
        <path
          d="M153.53 149.092l-6.06-2.66a3.175 3.175 0 011.748-1.805 3.179 3.179 0 012.512.035 3.478 3.478 0 011.8 4.43zM133.2 186.741c3.86 1.12 15.14 16.38 18.8 21.88l-4.14 10.56a48.795 48.795 0 016.53 8.43l-8.43 24.55s.76-32.71-12.76-57.6v-7.82z"
          fill="#263238"
        />
        <path
          d="M144.84 233.442c3 7.79 3.42 25.85 3.42 25.85s-3-16.85-17.17-22.75c0-.81.15-12.35.15-12.35s-19-4.82-23-6.63l-4.09-22s2.73-6.82 5-7v4.75a220.51 220.51 0 0117.93 15.78c10.36 9.99 14.78 16.56 17.76 24.35z"
          fill="#37474F"
        />
        <path
          d="M193.96 311.101c-3.06-2.57-7.49-6.13-11-7-.818-.236-1.65-.42-2.49-.55a26.508 26.508 0 003.49-1 6.342 6.342 0 002.84-2.24c.26-.41.42-1 0-1.32a.848.848 0 00-.51-.14c-2.59.13-4.66-.1-7-.08a10.135 10.135 0 00-3.16.32c-.94.35-1.88.71-2.8 1.11-4.17 1.84-8 3.5-14.16 2.59l-2.58-.68-43.38-22.35-8.23-44.8s-2-27.78-13.25-34.52c-6 2.28-12.57 7.92-14.35 14-2.1 7.23-1.28 17.5 2.3 33.43 3 13.33 6.13 27 9.52 37.15 3.39 10.15 4.69 13.74 11.35 15.73 11.17 3.34 51.47 14.39 51.47 14.39.825.319 1.666.596 2.52.83 1.39.39 2.69 1.35 6 2.07 3.93.86 8.71-.93 12-1.39 3.29-.46 9.07.62 12.26 1.62 3.19 1 6.5-4.06 8.09-3.61 1.59.45 4.14-.98 1.07-3.56z"
          fill="#FFA8A7"
        />
        <path
          d="M178.85 301.851c-1.612.06-3.195.451-4.65 1.15a25.764 25.764 0 016.23.56 26.729 26.729 0 003.49-1 6.684 6.684 0 002.59-1.89c-1.8 1.42-5.4 1.22-7.66 1.18z"
          fill="#F28F8F"
        />
        <path
          d="M91.18 200.142c-7.77 3.32-12.92 7.38-15 15.93s-.61 16.06 1.14 25.11 5.85 23.76 5.85 23.76 16.63 1 26.22-5.65l-5.25-34.12s-2.77-20.26-12.43-24.72"
          fill="#37474F"
        />
        <path
          d="M104.55 119.922c-5.84 5.41-11.44 13.08-7.29 30.83a9.626 9.626 0 00-2.41 10c1.6 5.48 6.86 9.09 11.75 8 4.89-1.09 7.54-6.31 5.94-11.8-1.21-4.1-5.61-8.07-9.23-7.81 0 0-3.47-7.59-.22-18.35 4.44-14.66 21.53-15.88 29.05-14.69-2.52-3.57-19.87-3.33-27.59 3.82z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 70%)"
        />
        <path
          opacity={0.4}
          d="M104.55 119.922c-5.84 5.41-11.44 13.08-7.29 30.83a9.626 9.626 0 00-2.41 10c1.6 5.48 6.86 9.09 11.75 8 4.89-1.09 7.54-6.31 5.94-11.8-1.21-4.1-5.61-8.07-9.23-7.81 0 0-3.47-7.59-.22-18.35 4.44-14.66 21.53-15.88 29.05-14.69-2.52-3.57-19.87-3.33-27.59 3.82z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M113.579 156.761c-1.78-6.08-7.61-10.07-13-8.93a8.275 8.275 0 00-2.35.88c-.61.34-2.45 1.6-2.81 1.84-3.46 2.29-5 7-3.63 11.84 1.78 6.08 7.61 10.07 13 8.93a8.455 8.455 0 002.8-1.14c.44-.28 2.16-1.43 2.58-1.73 3.31-2.33 4.8-6.92 3.41-11.69z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 40%)"
        />
        <path
          opacity={0.3}
          d="M113.579 156.761c-1.78-6.08-7.61-10.07-13-8.93a8.275 8.275 0 00-2.35.88c-.61.34-2.45 1.6-2.81 1.84-3.46 2.29-5 7-3.63 11.84 1.78 6.08 7.61 10.07 13 8.93a8.455 8.455 0 002.8-1.14c.44-.28 2.16-1.43 2.58-1.73 3.31-2.33 4.8-6.92 3.41-11.69z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M111.37 158.241c-1.78-6.07-7.61-10.07-13-8.92-5.39 1.15-8.36 7-6.58 13.07 1.78 6.07 7.61 10.07 13 8.93 5.39-1.14 8.36-7 6.58-13.08z"
          fill="var(--color-brand-hsl)"
        />
        <path
          opacity={0.1}
          d="M111.37 158.241c-1.78-6.07-7.61-10.07-13-8.92-5.39 1.15-8.36 7-6.58 13.07 1.78 6.07 7.61 10.07 13 8.93 5.39-1.14 8.36-7 6.58-13.08z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M106.2 159.342c-.84-2.87-3.6-4.75-6.15-4.21-2.55.54-4 3.3-3.11 6.17.89 2.87 3.6 4.75 6.15 4.21 2.55-.54 3.95-3.31 3.11-6.17z"
          fill="#37474F"
        />
      </g>
      <g>
        <path
          opacity={0.1}
          d="M225.459 374.371l-20.22-11.84a1 1 0 110-2l79.29-45.78a3.689 3.689 0 013.36 0l20.2 11.75a1 1 0 010 1.94l-79.28 45.94a3.656 3.656 0 01-3.35-.01z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M299.249 307.671l5.31-63a5.393 5.393 0 00-2.36-4.72 6.012 6.012 0 00-2.712-.592 6.016 6.016 0 00-2.688.692l-79.2 45.73a6.907 6.907 0 00-3.06 4.82l-5.3 63a5.351 5.351 0 002.35 4.72 5.996 5.996 0 005.41-.1l79.2-45.69a6.867 6.867 0 003.05-4.86z"
          fill="#263238"
        />
        <path
          d="M304.549 244.661l-5.3 63 3.85-62.54c.14-1.77-.5-2.44-2-1.56l-78.23 45.21a6.308 6.308 0 00-2 2.05l-5.23-3a6.126 6.126 0 012-2l79.19-45.73a6.057 6.057 0 015.42-.1 5.385 5.385 0 012.3 4.67z"
          fill="#37474F"
        />
        <path
          d="M214.469 356.622l5.31-63a6.87 6.87 0 013.05-4.82l78.23-45.27c1.54-.89 2.18-.21 2 1.56l-3.85 62.54a6.879 6.879 0 01-3.05 4.83l-79.2 45.72c-1.5.93-2.63.22-2.49-1.56z"
          fill="#455A64"
        />
        <path
          d="M253.38 318.541l-.61 18.98 22-12.65-5.36-15.54-16.03 9.21z"
          fill="#263238"
        />
        <path
          d="M256.59 320.631l15.359-8.92-2.62-1.51-15.35 8.93 2.611 1.5z"
          fill="#455A64"
        />
        <path
          d="M280.349 338.361l-8.4-26.65-15.36 8.93-2.6-1.52 1.72 20.52.43 5.9.25 1.26-1.12-.64-5-2.86a.831.831 0 00-.75-.1.77.77 0 00-.35.73v.45a2.398 2.398 0 001.08 1.9l8.22 4.75c.311.158.652.247 1 .26.414.019.825-.075 1.19-.27l18.71-10.8a1.93 1.93 0 00.98-1.86zm-11.81-2.28a3.232 3.232 0 01-5-2 6.194 6.194 0 012.75-6.54 3.204 3.204 0 011.477-.565 3.202 3.202 0 012.844 1.137c.342.412.576.903.679 1.428a6.178 6.178 0 01-2.75 6.54z"
          fill="#37474F"
        />
        <path
          d="M249.539 343.211l6.38-3.68 1.29 8.58-7.67-4.9z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M256.589 320.642l-2.61-1.51 2.16 26.4c.14.7-.26 1-.86.62l-5-2.86c-.61-.36-1.1-.06-1.1.64v.44a2.414 2.414 0 001.06 1.91l8.24 4.75c.309.161.651.25 1 .26l-2.89-30.65zM268.539 336.082a3.209 3.209 0 01-4.18-.45 3.658 3.658 0 002.33-.54 6.161 6.161 0 002.75-6.53 3.805 3.805 0 00-.83-1.59 3.254 3.254 0 012.67 2.57 6.18 6.18 0 01-2.74 6.54z"
          fill="#263238"
        />
        <path
          d="M255.379 295.982l-1 12.15c-.07.8.37 1.17 1 .82a2.886 2.886 0 001.22-2.07l1-12.14c.07-.81-.37-1.17-1-.83a2.935 2.935 0 00-1.22 2.07zM259.319 293.712l-1 12.14c-.07.8.37 1.17 1 .83.34-.24.624-.55.835-.908.21-.359.341-.759.385-1.172l1-12.14c.07-.8-.37-1.17-1-.82a2.915 2.915 0 00-1.22 2.07zM263.259 291.431l-1 12.15c-.07.8.37 1.17 1 .82a2.86 2.86 0 00.836-.902c.211-.357.342-.755.384-1.168l1-12.14c.07-.81-.37-1.17-1-.83a2.935 2.935 0 00-1.22 2.07zM267.199 289.161l-1 12.14c-.06.8.37 1.17 1 .83a2.923 2.923 0 001.22-2.08l1-12.14c.07-.8-.37-1.17-1-.82a2.915 2.915 0 00-1.22 2.07z"
          fill="var(--color-brand-hsl)"
        />
      </g>
      <g>
        <path
          d="M213.46 169.601c-6.4-6.61-10.17-33.51-3.92-38.76h31.79c6.25 5.24 2.49 32.14-3.91 38.75l-.18.18-.22.22a7.522 7.522 0 01-.58.52l-.15.12a9.989 9.989 0 01-1.31.91c-5.27 3.07-13.81 3.07-19.08 0-.29-.16-.56-.35-.84-.54-.28-.19-.3-.23-.45-.35-.15-.12-.13-.09-.19-.15s-.38-.33-.56-.5l-.25-.25-.15-.15z"
          fill="var(--color-brand-hsl)"
        />
        <path
          opacity={0.3}
          d="M213.46 169.601c-6.4-6.61-10.17-33.51-3.92-38.76h31.79c6.25 5.24 2.49 32.14-3.91 38.75l-.18.18-.22.22a7.522 7.522 0 01-.58.52l-.15.12a9.989 9.989 0 01-1.31.91c-5.27 3.07-13.81 3.07-19.08 0-.29-.16-.56-.35-.84-.54-.28-.19-.3-.23-.45-.35-.15-.12-.13-.09-.19-.15s-.38-.33-.56-.5l-.25-.25-.15-.15z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M238.569 128.73c7.25 4.24 7.25 11.1 0 15.34s-19 4.23-26.27 0-7.25-11.1 0-15.34 19.02-4.2 26.27 0z"
          fill="var(brand)"
        />
        <path
          opacity={0.1}
          d="M238.569 128.73c7.25 4.24 7.25 11.1 0 15.34s-19 4.23-26.27 0-7.25-11.1 0-15.34 19.02-4.2 26.27 0z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M235.08 130.77c5.33 3.11 5.33 8.15 0 11.26-5.33 3.11-14 3.11-19.29 0-5.29-3.11-5.33-8.15 0-11.26 5.33-3.11 13.97-3.11 19.29 0z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M215.79 136.111c5.33-3.11 14-3.11 19.29 0a8.867 8.867 0 013.19 3 8.793 8.793 0 01-3.19 3c-5.32 3.11-14 3.11-19.29 0a8.86 8.86 0 01-3.19-3 8.993 8.993 0 013.19-3z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 70%)"
        />
        <g>
          <path
            d="M243.06 83.92l-12.711 8.69 12.001-4.55a21.873 21.873 0 01-2.381 9.24s-7.94 3.851-12.25 7.911l10.571-3.32a51.635 51.635 0 01-1.711 11.64c-.91 3.36-3.999 9.61-5.899 12.84a39.659 39.659 0 01-2.911 4.3c-.06.09-.129.17-.199.26-2-1.31-4-2.6-6.12-3.85-1.23-3.12-2.571-10.7-2.821-16.85-.92-23.55 17.691-35.69 32.211-39.18a42.455 42.455 0 00-7.78 12.87z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.2}
            d="M243.06 83.92l-12.711 8.69 12.001-4.55a21.873 21.873 0 01-2.381 9.24s-7.94 3.851-12.25 7.911l10.571-3.32a51.635 51.635 0 01-1.711 11.64c-.91 3.36-3.999 9.61-5.899 12.84a39.659 39.659 0 01-2.911 4.3c-.06.09-.129.17-.199.26-2-1.31-4-2.6-6.12-3.85-1.23-3.12-2.571-10.7-2.821-16.85-.92-23.55 17.691-35.69 32.211-39.18a42.455 42.455 0 00-7.78 12.87z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M232.92 84.18a17.567 17.567 0 00-3.3 4 34.55 34.55 0 00-2.33 4.64 47.884 47.884 0 00-2.85 9.951 43.994 43.994 0 001.12 20.47.339.339 0 01-.469.359.34.34 0 01-.171-.159 44.452 44.452 0 01-.8-20.73 48.078 48.078 0 013-10 33.764 33.764 0 012.41-4.62 17.866 17.866 0 013.39-3.91z"
            fill="#FAFAFA"
          />
          <path
            d="M186.71 90.89a181.094 181.094 0 0112.06 18.101l12.18 2.35-9.07 1.3 4.61 7.82 12 2.87-9.45 1.24s2.33 9.26 8.94 13.29c3.65 2.23 5.46 2.61 6.61 1.58.8-.72 1.12-5.12 1.89-9 .77-3.88 1-10.29-2.45-18.12a23.978 23.978 0 00-3.68-5.78c-8.59-10.21-25.28-15.51-33.64-15.65z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.3}
            d="M186.71 90.89a181.094 181.094 0 0112.06 18.101l12.18 2.35-9.07 1.3 4.61 7.82 12 2.87-9.45 1.24s2.33 9.26 8.94 13.29c3.65 2.23 5.46 2.61 6.61 1.58.8-.72 1.12-5.12 1.89-9 .77-3.88 1-10.29-2.45-18.12a23.978 23.978 0 00-3.68-5.78c-8.59-10.21-25.28-15.51-33.64-15.65z"
            fill="#fff"
          />
          <path
            opacity={0.1}
            d="M221.469 116.321a36.845 36.845 0 012.5 10.2 109.37 109.37 0 01-.06 13.28c.254-.084.488-.216.69-.39.8-.72 1.12-5.12 1.89-9 .77-3.88 1-10.29-2.45-18.12a23.967 23.967 0 00-3.68-5.78c-8.61-10.2-25.3-15.5-33.63-15.64 12.72 2.49 26.2 11.41 32.68 21.51a25.58 25.58 0 012.06 3.94z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M199.43 95.291a49.908 49.908 0 0116.66 12.29 33.028 33.028 0 015.57 8.83 31.508 31.508 0 012.35 10.12 40.45 40.45 0 00-2.91-9.88 38.398 38.398 0 00-5.35-8.76 44.217 44.217 0 00-7.49-7.1 58.94 58.94 0 00-8.79-5.47s-.06-.03-.04-.03z"
            fill="#FAFAFA"
          />
          <path
            d="M262.71 99.581a25.9 25.9 0 00-3.08 0 49.209 49.209 0 00-11.92 2.18c-1.44.45-2.88 1-4.3 1.55-.72.29-1.42.6-2.12.93a34.403 34.403 0 00-9.4 6.32 21.6 21.6 0 00-3.34 4.19l-.37.59c-.29.52-.55 1-.81 1.54a29.492 29.492 0 00-3.45 14.34c-.07 3.52.9 7.59 1.55 8.29.088.091.185.171.29.24 1 .7 2.58.41 5.64-1.09 6.15-3 9-11.31 9-11.31l-8.2-1.87 10.75-1.53 4.69-6.5-7.93-1.92 10.86-1a160.998 160.998 0 0112.08-14.92l.06-.03z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.1}
            d="M259.59 99.53a49.198 49.198 0 00-11.88 2.231c-1.44.45-2.88 1-4.3 1.55-.72.29-1.42.6-2.12.93a34.403 34.403 0 00-9.4 6.32 21.57 21.57 0 00-3.34 4.19l-.37.59c-.29.52-.55 1-.81 1.54a29.492 29.492 0 00-3.45 14.34c-.07 3.52.9 7.59 1.55 8.29.088.09.185.171.29.24.193.135.41.23.64.28-.43-5.48 3-19.13 7.37-24.58 4.55-5.67 15-13.67 28.93-15.87a25.354 25.354 0 00-3.11-.05z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M226.32 140.04a46.646 46.646 0 011.45-12 38.817 38.817 0 014.62-11.19 27.36 27.36 0 013.91-4.68 38.699 38.699 0 014.67-3.89 44.84 44.84 0 0110.74-5.63 59.02 59.02 0 00-10.33 6.13 48.103 48.103 0 00-4.61 3.83 26.475 26.475 0 00-3.92 4.49 38.758 38.758 0 00-4.75 11 46.812 46.812 0 00-1.7 11.9l-.08.04z"
            fill="#FAFAFA"
          />
        </g>
        <g>
          <path
            d="M319.979 223.831h10.151l-1.63 9.9a1.834 1.834 0 01-1 1.23 5.446 5.446 0 01-4.91 0 1.853 1.853 0 01-1-1.23l-1.611-9.9zM375.709 193.971h10.15l-1.62 9.9a1.857 1.857 0 01-1 1.22 5.438 5.438 0 01-4.91 0 1.844 1.844 0 01-1-1.22l-1.62-9.9zM244.789 181.721h10.15l-1.62 9.9a1.793 1.793 0 01-1 1.22 5.387 5.387 0 01-4.91 0 1.793 1.793 0 01-1-1.22l-1.62-9.9zM296.42 151.691h10.15l-1.62 9.9a1.812 1.812 0 01-1 1.22 5.439 5.439 0 01-4.91 0 1.803 1.803 0 01-1-1.22l-1.62-9.9z"
            fill="#FAFAFA"
          />
          <path
            d="M236.709 129.691v47.28a10.923 10.923 0 004.9 8.56l4 2.32h.07a11.118 11.118 0 006.15 1.05l60.25 31.88a11.005 11.005 0 004.86 8.18h.05l4 2.3c.117.078.241.145.37.2l.21.1h.06a11.16 11.16 0 007.63.35c.292-.087.579-.19.86-.31a.766.766 0 01.13-.06c.2-.086.394-.186.58-.3l58-33.38a10.926 10.926 0 004.92-8.52l.08-59.85v-22.71a10.998 10.998 0 00-4.92-8.53l-64.84-37.36a10.17 10.17 0 00-9.5.16l-4 2.31a13.085 13.085 0 00-5.67 8.48l-3.86 25.33-3.57-2.06a10.678 10.678 0 00-10.71 0l-45.15 26.06a10.933 10.933 0 00-4.9 8.52z"
            fill="#37474F"
          />
          <path
            d="M310.559 63.361l4-2.31a10.172 10.172 0 019.5-.16l64.83 37.36c.29.17.6.39.51.32a11.24 11.24 0 014.36 7.38c-.36-2.52-2.41-3.43-4.86-2l-4 2.32a10.866 10.866 0 01-9.84 0l-64.49-37.2c-2.73-1.54-2.73-4.14-.01-5.71z"
            fill="#455A64"
          />
          <path
            d="M236.709 129.691v47.28a10.928 10.928 0 004.9 8.56l4 2.32h.07a10.551 10.551 0 005.77 1.09 9.737 9.737 0 004-1.13l45.58-26.28a10.924 10.924 0 004.92-8.53v-47.3a10.9 10.9 0 00-4.92-8.53l-3.57-2.06a10.679 10.679 0 00-10.71 0l-45.14 26.06a10.933 10.933 0 00-4.9 8.52z"
            fill="#263238"
          />
          <path
            d="M297.449 95.111l3.58 2.06c2.71 1.56 2.71 4.12 0 5.68l-45.56 26.31a10.92 10.92 0 00-4.93 8.53v47.27c0 3.13-2.22 4.41-4.93 2.85l-4-2.32a10.937 10.937 0 01-4.92-8.52v-47.28a11.003 11.003 0 014.92-8.53l45.14-26a10.663 10.663 0 0110.7-.05z"
            fill="#455A64"
          />
          <path
            d="M250.539 137.691v47.27c0 3.13-2.22 4.41-4.93 2.85l-4-2.32a10.93 10.93 0 01-4.92-8.52v-47.28a10.102 10.102 0 011.45-4.85l13.85 8a10.08 10.08 0 00-1.45 4.85z"
            fill="#37474F"
          />
          <path
            d="M252.59 188.941c.471.98 1.077 1.888 1.8 2.7a20.86 20.86 0 004.63 3.24c17.31 10 29.8 17.18 47.11 27.18a5.46 5.46 0 004.92 0l16-9.25 32-18.48a9.245 9.245 0 004.922-8.175 9.252 9.252 0 00-4.922-8.175l-18.14-10.45-13.85-8-15.05-8.66a10.876 10.876 0 00-9.85 0l-45.55 26.28a10.554 10.554 0 00-4.93 8.17 8.715 8.715 0 00.91 3.62z"
            fill="#263238"
          />
          <path
            d="M306.13 211.401l-52-30c-1.35-.78-2.46-.14-2.46 1.43v5a5.483 5.483 0 002.46 4.26l52 30c1.36.78 2.46.14 2.46-1.42v-5a5.42 5.42 0 00-2.46-4.27zM312.01 126.461l47.07 27.14a10.882 10.882 0 014.92 8.53v10a10.908 10.908 0 01-4.92 8.52l-45.57 26.27a10.872 10.872 0 01-9.84 0l-47.07-27.15a10.89 10.89 0 01-4.92-8.52v-10a10.908 10.908 0 014.92-8.53l45.57-26.3a10.862 10.862 0 019.84.04z"
            fill="#37474F"
          />
          <path
            d="M308.59 186.761v21.34a9.999 9.999 0 004.92-1.19l45.57-26.3a10.908 10.908 0 004.92-8.52v-10a11.006 11.006 0 00-4.42-8.21c2.2 1.58 2 3.9-.5 5.37l-45.57 26.3a9.996 9.996 0 01-4.92 1.21z"
            fill="#263238"
          />
          <path
            d="M303.71 185.591l-47.07-27.15c-2.71-1.57-2.71-4.11 0-5.68l45.57-26.3a10.869 10.869 0 019.84 0l47.07 27.14c2.72 1.57 2.72 4.12 0 5.69l-45.57 26.3a10.87 10.87 0 01-9.84 0z"
            fill="#455A64"
          />
          <g>
            <path
              d="M270.06 188.182s3.8 12.16 3.66 16.82c-.16 4.86.88 6.56-.39 11.75-.27 1.13-1.07 3.37-1.29 4.29a1.363 1.363 0 00.113 1.168 1.372 1.372 0 00.977.652c2.06.61 5.88-3 7.9-7.19a128.687 128.687 0 005.43-14.76 6.673 6.673 0 00-.38-3.44 10.034 10.034 0 00-.82-1.84c-.52-2.16-.51-6.19-.86-9l-14.34 1.55z"
              fill="#B16668"
            />
            <path
              d="M290.19 205.661c.235.515.38 1.066.43 1.63 0 1-2.48 4-3.43 5.05a7.771 7.771 0 00-2 5.36 13.408 13.408 0 01-3.95 8.33 21.314 21.314 0 01-11.13 6c-5.22 1.14-6.8-1.56-6.8-1.56s-1.38-2.59-.34-3.52c1.04-.93 27.22-21.29 27.22-21.29z"
              fill="#263238"
            />
            <path
              d="M285.26 195.632c.16 0 .43 0 .79.51.14.19.87 2.56 1.54 3.83s2.5 3.72 2.6 5.69c-1.5 3.67-5.26 6-6.09 9.52-.83 3.52-1.25 7.65-7.09 11.55-5.84 3.9-11.51 3.88-13.44 2.55-1.93-1.33-1.56-3.48 1.61-7.37 3.36-4.13 6.18-13.46 6.18-13.46.374-1.314.665-2.65.87-4a27.248 27.248 0 000-4 2.994 2.994 0 01.41-1.79c.425-.46.979-.781 1.59-.92.937-.345 1.91-.583 2.9-.71a4.478 4.478 0 012.87.59c.547.465 1.118.902 1.71 1.31a2.615 2.615 0 002.73-.25 2.255 2.255 0 00.94-2.41 5.77 5.77 0 00-.12-.64z"
              fill="#455A64"
            />
            <path
              d="M280.51 223.531a8.769 8.769 0 00-7.58-5c-5.82-.46-8.08 2.33-9.11 4-1.23 2-2.64 5.65-.33 6.93 2.49 1.38 5.52 1.28 10.45-.69s6.57-5.24 6.57-5.24zM280.919 205.902a.63.63 0 01-.53-.05c-.86-.53-5.53-1.93-8.51.41-.34-.32-.22-.84.3-1.54 3.42-1.79 7.84-.49 8.88.16a.553.553 0 01.248.584.555.555 0 01-.088.206.612.612 0 01-.3.23zM270.989 209.601a1.83 1.83 0 01.481-1.57 10.87 10.87 0 018.44.37.566.566 0 01.247.585.607.607 0 01-.907.385c-.84-.51-5.271-1.84-8.261.23zM267.96 217.261a3.371 3.371 0 01.92-2.05c3.39-1.67 7.71-.4 8.74.23a.567.567 0 01.248.367.573.573 0 01-.088.433.668.668 0 01-.3.23.61.61 0 01-.53-.05c-.9-.56-6.05-2.08-8.99.84zM278.63 212.941a.582.582 0 01-.53 0c-.85-.53-5.42-1.89-8.41.33a2.008 2.008 0 01.63-1.68 10.855 10.855 0 014.257-.668c1.45.063 2.872.416 4.183 1.038a.575.575 0 01.226.538.575.575 0 01-.356.462v-.02z"
              fill="#FAFAFA"
            />
            <path
              d="M263.71 202.182s-3.591 14.15-6.701 19.49c-3.11 5.34-4.699 7.92-8.699 11.82-.87.85-2.82 2.4-3.53 3.09a1.427 1.427 0 00-.523 1.11 1.444 1.444 0 00.523 1.11c1.49 1.69 8.329 2.63 12.419.07s8.121-8.41 10.611-10.54c.94-.8 1.82-1.62 2.68-2.5.86-.88.689-1.74.839-2.75.07-.5.111-1.85.111-1.85.73-2.37 2.48-6 3.43-8.33l-11.16-10.72z"
              fill="#B16668"
            />
            <path
              d="M271.81 232.182a5.279 5.279 0 01-.33 1.74c-.46.9-4.11 2.64-5.5 3.24a8.155 8.155 0 00-4.27 4.17 14.007 14.007 0 01-7.46 6.11 22.218 22.218 0 01-13.22.72c-5.45-1.26-5.73-4.52-5.73-4.52s-.15-3.06 1.25-3.48c1.4-.42 35.26-7.98 35.26-7.98z"
              fill="#263238"
            />
            <path
              d="M271.62 220.531c.15.08.42.19.53.83 0 .25-.32 2.82-.25 4.31.07 1.49.7 4.64-.09 6.55-3.06 2.81-7.66 3.33-10 6.29s-4.59 6.69-11.87 7.77c-7.28 1.08-12.62-1.48-13.85-3.59-1.23-2.11.07-4 4.81-6.26 5-2.41 11.86-10 11.87-10a33.241 33.241 0 002.6-3.39 28.502 28.502 0 001.77-3.83 3.122 3.122 0 011.18-1.51 3.21 3.21 0 011.92-.15c1.039.092 2.065.297 3.06.61a4.734 4.734 0 012.45 1.85c.39.64.58 1.4 1 2a2.749 2.749 0 002.7 1 2.33 2.33 0 002-1.86c.068-.203.125-.41.17-.62z"
              fill="#455A64"
            />
            <path
              d="M254.71 244.751a9.15 9.15 0 00-4.95-8.08c-5.3-3.05-8.68-1.42-10.4-.3-2.05 1.33-5 4.16-3.41 6.41 1.74 2.42 4.66 3.67 10.2 4 5.54.33 8.56-2.03 8.56-2.03zM262.93 228.271a.636.636 0 01-.48-.28c-.57-.89-4.37-4.3-8.24-3.42-.17-.45.17-.89 1-1.32 4-.16 7.63 3 8.33 4.11a.583.583 0 01-.21.82.654.654 0 01-.4.09zM251.89 227.332a1.87 1.87 0 011.14-1.27 11.435 11.435 0 017.83 4.12.57.57 0 01.072.455.581.581 0 01-.282.365.644.644 0 01-.86-.19c-.55-.86-4.16-4.09-7.9-3.48zM245.59 233.231a3.56 3.56 0 011.79-1.53c4-.06 7.48 3.07 8.16 4.13a.575.575 0 01.077.453.577.577 0 01-.277.367.645.645 0 01-.38.08.603.603 0 01-.48-.28c-.61-.92-4.77-4.68-8.89-3.22zM257.619 233.912a.602.602 0 01-.48-.28c-.57-.88-4.29-4.21-8.11-3.44a2.133 2.133 0 011.34-1.31 11.47 11.47 0 017.83 4.12.592.592 0 01-.2.83.645.645 0 01-.38.08z"
              fill="#FAFAFA"
            />
            <path
              d="M302.209 123.171c-6.25 3.81-27.73 13.91-36.69 20.91-2.59 2-3.63 4.88-3.58 11.31.07 8.73 4.39 38.81 4.39 38.81.8 1.75 2.71-1.28 2.71-1.28l35.93-38.46-2.76-31.29z"
              fill="var(--color-brand-hsl)"
            />
            <path
              opacity={0.3}
              d="M302.209 123.171c-6.25 3.81-27.73 13.91-36.69 20.91-2.59 2-3.63 4.88-3.58 11.31.07 8.73 4.39 38.81 4.39 38.81.8 1.75 2.71-1.28 2.71-1.28l35.93-38.46-2.76-31.29z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
            <path
              opacity={0.3}
              d="M268.51 185.131c8-5.64 35.53-41.87 35.53-41.87-3.07-3.07-4-12.89-4-12.89-1.62 3.62-.72 9.37.13 11.51-2.05 1.49-13.59 9.46-21.59 14.76a10.75 10.75 0 00-5 6.34c-2.21 7.98-5.1 20.49-5.07 22.15z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
            <path
              d="M302.209 123.171l41 12.77c-2.68 7.5-3.6 11.41-6.07 15.27-2.47 3.86-5.21 8-16.52 12.42-10.9 4.27-24.13 8.5-26.79 9.5-2 .75-3.24 4.53-4.54 9.45-1.35 5.16-1.78 9.26-7.89 19.81-6 10.34-7.21 12.58-7.21 12.58s-7.92.15-12.75-4.87c0 0 10.22-36.31 12.3-42.83 1.16-3.64 1.34-5.59 6.29-9.28 4.25-3.17 23-15 23-15s-6.2-10.04-.82-19.82z"
              fill="var(--color-brand-hsl)"
            />
            <path
              opacity={0.3}
              d="M302.209 123.171l41 12.77c-2.68 7.5-3.6 11.41-6.07 15.27-2.47 3.86-5.21 8-16.52 12.42-10.9 4.27-24.13 8.5-26.79 9.5-2 .75-3.24 4.53-4.54 9.45-1.35 5.16-1.78 9.26-7.89 19.81-6 10.34-7.21 12.58-7.21 12.58s-7.92.15-12.75-4.87c0 0 10.22-36.31 12.3-42.83 1.16-3.64 1.34-5.59 6.29-9.28 4.25-3.17 23-15 23-15s-6.2-10.04-.82-19.82z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
            <path
              d="M304.34 66.532c-.79-.47-1.14-5.74-.3-9.5.84-3.76-.9-4.68-1.76-3.5a6.165 6.165 0 00-1.06 2.19 10.481 10.481 0 00-4.9 2.61c-2.11 2.09-4.59 4.64-3.86 10.21a14.516 14.516 0 01-.38 5.54c-3 8.18-13.66 18.42-16.06 29.33-2.22 10 5.61 11 12.45 8 7.86-3.53 22.92-16.9 22.92-16.9l6.53-21.91c-4.15 0-7.24.67-12.75 6-.92.89-4.75 4.16-4.75 4.16a44.974 44.974 0 013.92-7.68"
              fill="#B16668"
            />
            <path
              d="M294.859 97.142a47.543 47.543 0 01-4 7.25 14.282 14.282 0 005.13-6l-1.13-1.25z"
              fill="#9A4A4D"
            />
            <path
              d="M318.819 72.592c-4.5-.42-8.14.28-11.67 3.69-3.25 3.15-6.73 6.47-6.73 6.47-2.33 5.42-4 10.68-5.56 14.39a19.624 19.624 0 004.18 7.87l18.24-14.65 1.54-17.77z"
              fill="#FAFAFA"
            />
            <path
              d="M301.959 72.601c1.26-2-.59-3.94-.59-3.94l3-2v-.13l-12-.54c-.04.858-.003 1.719.11 2.57.09.864.12 1.732.09 2.6l1.56.93a1.172 1.172 0 001.12 0l5.05-2.61c1.73.73 1.66 3.12 1.66 3.12z"
              fill="#9A4A4D"
            />
            <path
              d="M292.28 55.89l21-9.91a1.171 1.171 0 011.18 0c.26.17 1.34.84 1.64 1a1.119 1.119 0 01.53 1l.68 10.87a2.67 2.67 0 01-1.44 2.38l-21 9.91a1.237 1.237 0 01-1.11 0c-.3-.17-1.47-.89-1.78-1.09a1.186 1.186 0 01-.46-.92l-.68-10.87a2.663 2.663 0 011.44-2.37z"
              fill="#37474F"
            />
            <path
              d="M315.86 59.101a1.472 1.472 0 01-.72 1.19l-19.87 9.39v.48l-.81-11.57a1.43 1.43 0 01.71-1.17l20.32-9.63-.44.21.81 11.1z"
              fill="var(--color-brand-hsl)"
            />
            <path
              opacity={0.75}
              d="M315.86 59.101a1.472 1.472 0 01-.72 1.19l-19.87 9.39v.48l-.81-11.57a1.43 1.43 0 01.71-1.17l20.32-9.63-.44.21.81 11.1z"
              fill="#fff"
            />
            <path
              d="M316.35 59.372a1.475 1.475 0 01-.72 1.18l-20.33 9.61v-.48l19.87-9.39a1.473 1.473 0 00.72-1.19l-.78-11.09.44-.21.8 11.57zM293.82 71.18h-.06c-.3-.17-1.47-.89-1.78-1.09a1.186 1.186 0 01-.46-.92l-.68-10.87a2.617 2.617 0 01.73-1.84l1.71 1a2.607 2.607 0 00-.74 1.85l.68 10.88a1.106 1.106 0 00.6.99z"
              fill="#263238"
            />
            <path
              d="M316.11 46.981a1.255 1.255 0 00-1.08 0l-21 9.92c-.269.125-.51.302-.71.52l-1.72-1c.205-.222.449-.405.72-.54l21-9.91a1.209 1.209 0 011.17 0c.22.18 1.22.8 1.62 1.01z"
              fill="#455A64"
            />
            <path
              opacity={0.35}
              d="M293.99 63.832a.786.786 0 00-.41.71.3.3 0 00.47.27.8.8 0 00.41-.71.3.3 0 00-.47-.27z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
            <path
              d="M304.71 66.531c.63-.52.86-2.15 1.93-3.62 1.24-1.69 4.1-1.25 3.21.12-.89 1.37-1.2 2.61-1.85 6.1-.65 3.49-2.05 4-3.61 6v-8.41l.32-.19z"
              fill="#B16668"
            />
            <path
              d="M333.62 74.262c3.45.91 14.6 5.31 14.6 5.31 2.4 1.88 1.39 6 1.35 10.73-.93 34.3-6.87 49.58-6.87 49.58-13.42 2.94-37.93-5.59-42.49-15.83 4.1-6.23 6.86-15.54 7.44-33.82.43-13.57 6.6-17.67 10.6-17.64a65.832 65.832 0 0115.37 1.67z"
              fill="#EBEBEB"
            />
            <path
              d="M316.52 46.041a4.899 4.899 0 000-2.4c-.24-.85-.56-1.67-.77-2.52-.27-1.15-.58-2.3-.92-3.43a16.452 16.452 0 01-1.12-4.88 2.989 2.989 0 01.83-2.17 2.993 2.993 0 012.92-.49c.969.371 1.866.91 2.65 1.59a5.529 5.529 0 011-3.45 3.194 3.194 0 013.23-1.22c1.12.31 1.89 1.32 2.79 2.06 1.64 1.35 3.8 1.83 5.86 2.36a14.545 14.545 0 015.95 2.53 9.329 9.329 0 013.52 7c0 1-.42 3.47-.58 4.79-.25 2-.46 4-.78 5.93-1.64 10-4.91 17.26-15 16.52-3.84-.29-9.2-2.67-10.2-6.85a14.48 14.48 0 01-.19-2.19c-.1-1.47-.14-3-.11-4.42.062-2.94.37-5.87.92-8.76z"
              fill="#263238"
            />
            <path
              d="M342.5 41.052s1.94.07 3 2.6c.89 2.2 1.3 5.67-.86 11-2.28 5.65-4.07 7.42-5.31 9.52-.89 1.51-2.31 4.35-2.31 4.35l.63-6.64.57-4.61s-2.84-.65-3.66-5.26c-.93-5.18.05-5.83.05-5.83l7.89-5.13z"
              fill="#455A64"
            />
            <path
              d="M337.98 56.731a1.147 1.147 0 001.09-.08c.92-.54 1.35-1.7 2.13-2.4 1-.91 4.16-2 5.45 1.3s-1.95 7.64-4.31 8.54c-3.47 1.32-4.73-2.17-4.73-2.17l-1.34 14c-4 6.12-8.29 6.61-12.39 6.32-4.1-.29-3.79-4.1-1.16-6.72l.35-4.56a26.773 26.773 0 01-5.62-.12c-3-.7-4.45-3.11-5.13-6.49a44.963 44.963 0 01-.48-11.87 49.425 49.425 0 012.3-10.76s1.74-1.58 6.79-1.66c3.57 0 8.07-.3 9.94 1.94a5.106 5.106 0 003.7 4.26c-1.08 7.16 2.81 10.21 3.41 10.47z"
              fill="#B16668"
            />
            <path
              d="M330.999 42.581c-.74-1.36-3.37-2-4.89-1.78a35.475 35.475 0 00-6.16 1.9 14.498 14.498 0 01-4.62.77 8.332 8.332 0 01-4.3-1.1 5 5 0 01-.21-7.74 2.062 2.062 0 001 1.68 6.172 6.172 0 001.89.72 3.73 3.73 0 01-1.25-3.51 4.917 4.917 0 012.87-3.29c1.2-.34 2.59-.7 5.25 1.5s11.7 3.52 10.42 10.85z"
              fill="#263238"
            />
            <path
              d="M323.07 70.92s6.91-.87 9.38-2a7.92 7.92 0 003.54-3 10.776 10.776 0 01-2.16 3.7c-1.9 2.1-10.9 3.08-10.9 3.08l.14-1.78z"
              fill="#9A4A4D"
            />
            <path
              d="M325.92 53.242a1.374 1.374 0 00.79 1.288c.243.113.515.153.78.113a1.37 1.37 0 00-.1-2.721 1.401 1.401 0 00-1.47 1.32zM326.81 48.182l2.9 1.58a1.754 1.754 0 00-.71-2.32 1.635 1.635 0 00-1.802.233 1.611 1.611 0 00-.388.507z"
              fill="#263238"
            />
            <path
              d="M326.18 61.791l-5.87 1.74a3.006 3.006 0 001.405 1.887 3 3 0 002.335.293 3.198 3.198 0 002.13-3.92z"
              fill="#9A4A4D"
            />
            <path
              d="M324.05 65.692a3 3 0 01-1.59 0 2.768 2.768 0 012.95-2.46c.264.015.524.072.77.17a3.147 3.147 0 01-2.13 2.29z"
              fill="#F28F8F"
            />
            <path
              d="M313.71 48.532l3.24-1a1.611 1.611 0 00-2-1.17 1.767 1.767 0 00-1.24 2.17zM314.71 52.371a1.37 1.37 0 00.31 1.025 1.378 1.378 0 00.95.495 1.418 1.418 0 001.569-1.552 1.425 1.425 0 00-1.014-1.222 1.42 1.42 0 00-1.815 1.254z"
              fill="#263238"
            />
            <path
              d="M321.859 50.781l-.99 9.24-4.63-1.97 5.62-7.27z"
              fill="#9A4A4D"
            />
          </g>
          <path
            d="M325.92 228.462v-47.28a11.002 11.002 0 014.92-8.53l45.63-26.33a3.253 3.253 0 001.184-4.431 3.253 3.253 0 00-1.184-1.189l-1.12-.64 3.87-25.33a13.078 13.078 0 015.67-8.48l4-2.31c2.71-1.57 4.92-.29 4.92 2.84v22.75l-.1 59.86a10.898 10.898 0 01-4.92 8.52l-58 33.39c-2.65 1.56-4.87.28-4.87-2.84z"
            fill="#263238"
          />
          <path
            d="M312.08 173.182v47.6a11 11 0 004.86 8.18h.05l4 2.3c.117.078.241.145.37.2l.21.1h.06c.125.061.256.111.39.15 2.328.85 4.869.92 7.24.2.292-.087.58-.191.86-.31-2.37 1-4.2-.36-4.21-3.19v-47.23a10.933 10.933 0 014.92-8.53l8.94-5.16 36.69-21.17a3.253 3.253 0 001.184-4.431 3.238 3.238 0 00-1.184-1.189l-4.07-2.35a10.92 10.92 0 00-9.84 0l-36.63 21.18-8.92 5.15a10.894 10.894 0 00-4.92 8.5z"
            fill="#455A64"
          />
          <path
            d="M325.92 181.181v47.27c0 2.83 1.84 4.16 4.21 3.19-.281.12-.568.223-.86.31a11.414 11.414 0 01-7.24-.2 2.361 2.361 0 01-.39-.15h-.06l-.21-.1a2.278 2.278 0 01-.37-.2l-4-2.3h-.05a11.004 11.004 0 01-4.86-8.18v-47.64c.06-1.713.555-3.382 1.44-4.85l13.85 8a9.996 9.996 0 00-1.46 4.85z"
            fill="#37474F"
          />
          <g>
            <path
              d="M366.58 127.531c-1.33-10.42-2.44-15.84-3.81-22.83-3.19-16.22-2.44-20.88-14.17-23.93 0 0-4.25 3.74-4.43 13.34-.13 7.25 2 11.24 2 11.24l5 24c-4.33 4-15.43 12.72-18.14 14.15-3.65 1.94-7.7 2.69-11.6 4-2.59.89-5 2-7.54 3.06-.141.042-.27.113-.38.21a.779.779 0 00-.16.83c.122.277.324.51.58.67a4.85 4.85 0 004.2.57c1.19-.27 2.21-.9 3.62-.86.27 0 .56.08.45.42a2.454 2.454 0 01-.43.64 9.766 9.766 0 01-3.94 1.9c-1.367.385-2.78.587-4.2.6a17.104 17.104 0 00-3.42.23c-.36.072-.701.218-1 .43-1.55 1.21.91 2.14 1.41 3 .26.44.72 1.22 1 1.63.34.337.75.597 1.2.76.56.354 1.097.742 1.61 1.16a7.825 7.825 0 004.43 1.15 24.696 24.696 0 003.94-.41 16.78 16.78 0 007.61-2.96 22.715 22.715 0 002.6-2.41c.7-.73 1.39-1.48 2.14-2.18a44.46 44.46 0 013.86-2.93c1.95-1.13 13.13-6.42 24.34-14.24 4.92-3.45 3.82-6.68 3.23-11.24z"
              fill="#B16668"
            />
            <path
              d="M348.22 79.531c8.31 2.7 10.57 6.21 11.36 8.87 1.15 3.83 2 8.2 3.38 14.67 2 9.68 2.36 13.51 2.36 13.51s-4.58 3.71-16.48 3.56l-4-15.74s-5.79-13.77 3.38-24.87z"
              fill="#FAFAFA"
            />
          </g>
        </g>
        <g>
          <path
            d="M360.35 236.251l6.37-3.68-6.37-1.84v5.52z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.6}
            d="M360.35 236.251l6.37-3.68-6.37-1.84v5.52z"
            fill="#fff"
          />
          <path
            opacity={0.05}
            d="M360.35 236.251l6.37-3.68-6.37-1.84v5.52z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M360.35 236.252l-3.19-1.84v-5.52l3.19 1.84v5.52z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.75}
            d="M360.35 236.252l-3.19-1.84v-5.52l3.19 1.84v5.52z"
            fill="#fff"
          />
          <path
            d="M392.27 249.162v5.87l46.1-26.61v-5.87l-46.1 26.61z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.6}
            d="M392.27 249.162v5.87l46.1-26.61v-5.87l-46.1 26.61z"
            fill="#fff"
          />
          <path
            opacity={0.1}
            d="M392.27 249.162v5.87l46.1-26.61v-5.87l-46.1 26.61z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M392.27 255.031l-3.19-1.84v-5.87l3.19 1.84v5.87z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.75}
            d="M392.27 255.031l-3.19-1.84v-5.87l3.19 1.84v5.87z"
            fill="#fff"
          />
          <path
            d="M441.559 176.562l-46.11 26.61v47.83l46.11-26.61v-47.83z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.6}
            d="M441.559 176.562l-46.11 26.61v47.83l46.11-26.61v-47.83z"
            fill="#fff"
          />
          <path
            d="M395.45 203.172l-41.48-23.95v47.83l41.48 23.95v-47.83z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.75}
            d="M395.45 203.172l-41.48-23.95v47.83l41.48 23.95v-47.83z"
            fill="#fff"
          />
          <path
            d="M353.97 179.221l46.11-26.61 41.48 23.95-46.11 26.61-41.48-23.95z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.85}
            d="M353.97 179.221l46.11-26.61 41.48 23.95-46.11 26.61-41.48-23.95z"
            fill="#fff"
          />
          <path
            d="M392.27 219.731l-35.11-20.27v25.75l35.11 20.27v-25.75z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.7}
            d="M392.27 219.731l-35.11-20.27v25.75l35.11 20.27v-25.75z"
            fill="#fff"
          />
          <path
            opacity={0.1}
            d="M357.16 225.211l22.15-12.96 12.96 7.48v25.75l-35.11-20.27z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            opacity={0.05}
            d="M357.16 225.211l22.15-12.96-22.15-12.79v25.75z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            d="M392.27 205.011l-35.11-20.27v11.04l35.11 20.27v-11.04z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.85}
            d="M392.27 205.011l-35.11-20.27v11.04l35.11 20.27v-11.04z"
            fill="#fff"
          />
          <path
            d="M381.38 201.051c0 .51-1.52 0-3.39-1l-5.95-3.52c-1.88-1.08-3.4-2.37-3.4-2.88v-.92l12.74 7.36v.96z"
            fill="#455A64"
          />
          <g opacity={0.1}>
            <path
              opacity={0.1}
              d="M418.539 182.821a15.82 15.82 0 008.66-2.36c2-1.34 3.13-3 3.13-4.73 0-1.73-1.11-3.39-3.13-4.73a17.088 17.088 0 00-17.33 0c-2 1.34-3.13 3-3.13 4.73 0 1.73 1.11 3.39 3.13 4.73a15.83 15.83 0 008.67 2.36z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
          </g>
          <g>
            <path
              d="M410.79 175.161c0-.205.02-.409.06-.61a9.22 9.22 0 013.74-5.58h7.83a9.22 9.22 0 013.74 5.58c.04.204.06.412.06.62v.1a3.94 3.94 0 01-2.25 3 12.05 12.05 0 01-10.91 0 3.94 3.94 0 01-2.25-3 1.06 1.06 0 01-.02-.11z"
              fill="#37474F"
            />
            <path
              d="M422.21 168.841c2.05 1.19 2.05 3.1 0 4.29a8.216 8.216 0 01-7.42 0c-2-1.19-2-3.1 0-4.29a8.216 8.216 0 017.42 0z"
              fill="#455A64"
            />
            <path
              d="M417.44 142.741h2.13v27.43a.473.473 0 01-.3.48 1.663 1.663 0 01-1.51 0 .484.484 0 01-.3-.48l-.02-27.43z"
              fill="#263238"
            />
            <path
              d="M402.77 138.631l7.41-18.89h16.66l7.41 18.89c1.05 3-.4 6.15-4.37 8.45-6.28 3.62-16.45 3.62-22.73 0-3.98-2.3-5.44-5.49-4.38-8.45z"
              fill="var(--color-brand-hsl)"
            />
            <path
              d="M424.53 124.261a13.318 13.318 0 01-12.05 0c-3.33-1.92-3.33-5 0-7a13.319 13.319 0 0112.05 0c3.33 1.96 3.33 5.08 0 7z"
              fill="var(--color-brand-hsl)"
            />
            <path
              opacity={0.3}
              d="M424.53 124.261a13.318 13.318 0 01-12.05 0c-3.33-1.92-3.33-5 0-7a13.319 13.319 0 0112.05 0c3.33 1.96 3.33 5.08 0 7z"
              fill="#fff"
            />
            <path
              d="M418.5 124.72a11.308 11.308 0 005.54-1.31c1.29-.75 2-1.68 2-2.63a3.32 3.32 0 00-2-2.62 12.353 12.353 0 00-11.07 0 3.312 3.312 0 00-1.348 1.045 3.31 3.31 0 00-.652 1.575c0 .95.71 1.88 2 2.63a11.29 11.29 0 005.53 1.31z"
              fill="var(--color-brand-hsl)"
            />
            <path
              opacity={0.15}
              d="M418.5 124.72a11.308 11.308 0 005.54-1.31c1.29-.75 2-1.68 2-2.63a3.32 3.32 0 00-2-2.62 12.353 12.353 0 00-11.07 0 3.312 3.312 0 00-1.348 1.045 3.31 3.31 0 00-.652 1.575c0 .95.71 1.88 2 2.63a11.29 11.29 0 005.53 1.31z"
              fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          d="M120.71 78.701l-4-7.38 3.16-9.12v-5.59l-9.67 5.59v5.58l4.15 7.2a.588.588 0 00.29.25l6.07 3.47z"
          fill="var(--color-brand-hsl)"
        />
        <path
          opacity={0.2}
          d="M120.71 78.701l-4-7.38 3.16-9.12v-5.59l-9.67 5.59v5.58l4.15 7.2a.588.588 0 00.29.25l6.07 3.47z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          d="M145.71 22.792a6.43 6.43 0 00-2.9-5l-2.36-1.36a6.377 6.377 0 00-5.8 0l-46.14 26.61a6.4 6.4 0 00-2.9 5v28.28a6.4 6.4 0 002.9 5l2.36 1.37a6.44 6.44 0 005.8 0l19.64-11.43 4.15 7.18a.624.624 0 00.592.307.622.622 0 00.528-.407l4.38-12.66 16.83-9.62a6.437 6.437 0 002.9-5l.02-28.27z"
          fill="var(--color-brand-hsl)"
        />
        <path
          opacity={0.2}
          d="M85.61 76.341a6.4 6.4 0 002.9 5l2.36 1.37a6.51 6.51 0 005.3.23c-1.36.52-2.4-.25-2.4-1.91v-28.26a5.83 5.83 0 01.85-2.85l-8.16-4.72a5.9 5.9 0 00-.85 2.86v28.28z"
          fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
        />
        <path
          opacity={0.4}
          d="M145.601 21.972c-.34-1.23-1.46-1.62-2.8-.85l-46.09 26.63a5.81 5.81 0 00-2 2.17l-8.15-4.71a5.76 5.76 0 012-2.16l46.12-26.64a6.437 6.437 0 015.8 0l2.37 1.37a6.423 6.423 0 012.75 4.19z"
          fill="#fff"
        />
        <path
          className="char2-speech-dot"
          d="M105.551 55.652a8.532 8.532 0 00-3.87 6.7c0 2.47 1.73 3.47 3.87 2.23a8.538 8.538 0 003.87-6.7c0-2.47-1.71-3.47-3.87-2.23zM119.81 47.402a8.569 8.569 0 00-3.87 6.7c0 2.46 1.74 3.46 3.87 2.23a8.535 8.535 0 003.9-6.7c0-2.47-1.76-3.47-3.9-2.23zM134.08 39.141a8.555 8.555 0 00-3.87 6.7c0 2.47 1.73 3.47 3.87 2.24a8.553 8.553 0 003.87-6.7c0-2.47-1.73-3.47-3.87-2.24z"
          fill="#FAFAFA"
        />
        <g>
          <path
            d="M247.76.181l36.56 21.1a1.632 1.632 0 01.74 1.28v25.6a1.621 1.621 0 01-.74 1.27l-2.61 1.51a1.623 1.623 0 01-1.47 0l-36.59-21.11a1.665 1.665 0 01-.73-1.28V2.911a1.592 1.592 0 01.74-1.26l2.63-1.48a1.62 1.62 0 011.47.01z"
            fill="var(--color-brand-hsl)"
          />
          <path
            d="M280.95 50.532v-25.66a1.64 1.64 0 00-.74-1.28l-36.56-21.06c-.4-.24-.73-.05-.73.42v25.58a1.656 1.656 0 00.73 1.28l36.56 21.12c.41.24.74.05.74-.4z"
            fill="var(--color-brand-hsl)"
          />
          <path
            d="M280.95 50.532v-25.66a1.64 1.64 0 00-.74-1.28l-36.56-21.06c-.4-.24-.73-.05-.73.42v25.58a1.656 1.656 0 00.73 1.28l36.56 21.12c.41.24.74.05.74-.4z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.2}
            d="M280.21 50.931a1.67 1.67 0 001.48 0l2.63-1.51a1.625 1.625 0 00.74-1.27v-25.62a1.406 1.406 0 00-.24-.75l-4.11 2.36c.133.221.209.472.22.73v25.66c.02.41-.29.65-.72.4z"
            fill="hsl(var(--color-brand-hue) var(--color-brand-saturation) 20%)"
          />
          <path
            opacity={0.4}
            d="M242.93 2.781c.06-.37.36-.5.72-.29l36.56 21.1c.216.137.395.326.52.55l4.1-2.33a1.46 1.46 0 00-.51-.53L247.76.181a1.622 1.622 0 00-1.47 0l-2.58 1.46a1.628 1.628 0 00-.78 1.14z"
            fill="#fff"
          />
          <path
            d="M287.07 41.211l4-2.28a.673.673 0 00.321-.491.677.677 0 00-.181-.559l-6.25-7.8-4 2.3 6.24 7.8a.692.692 0 01-.13 1.03z"
            fill="var(--color-brand-hsl)"
          />
          <path
            opacity={0.4}
            d="M287.07 41.211l4-2.28a.673.673 0 00.321-.491.677.677 0 00-.181-.559l-6.25-7.8-4 2.3 6.24 7.8a.692.692 0 01-.13 1.03z"
            fill="#fff"
          />
          <path
            d="M280.95 32.382l6.25 7.8a.654.654 0 01.157.701.667.667 0 01-.577.429l-5.83.63v-9.56z"
            fill="var(--color-brand-hsl)"
          />
          <path
            className="char1-speech-dot"
            d="M272.16 28.532c0 1-.72 1.34-1.6.82l-20.31-11.7a3.525 3.525 0 01-1.6-2.72c0-1 .72-1.34 1.6-.82l20.31 11.72a3.533 3.533 0 011.6 2.7zM276.71 39.032c0 1-.72 1.34-1.6.82l-24.86-14.32a3.525 3.525 0 01-1.6-2.72c0-1 .72-1.34 1.6-.82l24.84 14.33a3.527 3.527 0 011.62 2.71z"
            fill="#FAFAFA"
          />
        </g>
      </g>
    </svg>
  );
}
